import { useState } from "react";
import { useTranslation } from "react-i18next";

const FAQ_KEYS = [
  { q: "faq.q1", a: "faq.a1" },
  { q: "faq.q2", a: "faq.a2" },
  { q: "faq.q3", a: "faq.a3" },
  { q: "faq.q4", a: "faq.a4" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-3xl px-4 py-16 md:px-6">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{t("faq.title")}</h2>
        <p className="mt-3 text-foreground-600">{t("faq.subtitle")}</p>
      </div>

      <div className="mt-10 flex flex-col gap-3">
        {FAQ_KEYS.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={item.q} className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">{t(item.q)}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                    isOpen ? "rotate-45 bg-primary-100 text-primary-700" : ""
                  }`}
                >
                  <i className="ri-add-line text-base"></i>
                </span>
              </button>
              {isOpen && (
                <div className="border-t border-background-200/70 px-5 py-4">
                  <p className="text-sm leading-relaxed text-foreground-600">{t(item.a)}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}